import React from "react";
import {observer} from "mobx-react-lite";
import {Button} from "primereact/button";

import systemStore from "../storage/SystemStore";


const Btn = ({
    type = "button",
    size = "small",
    className = "",
    disabled = false,
    loading = false,
    ...rest
}) => {

    const isDisabled =
        disabled ||
        loading ||
        systemStore.loading;


    return (
        <Button
            {...rest}

            type={type}
            size={size}

            className={className}

            disabled={isDisabled}
            loading={loading}
        />
    );
};


export default observer(Btn);